/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import { TextField, Box, Tabs, Tab, Typography, FormControlLabel } from '@mui/material';
import { ENTER_NEW_DESCRIPTION, ENTER_NEW_ROLE, LABEL_BTN_CANCEL, LABEL_BTN_SAVE, LABEL_UPDATE_PERMISSION, LABEL_UPDATE_USERS, NEW_ROLE_SUCCESS_MESSAGE, UNKNOWN_ERR } from 'src/constants/constant';
import { addRole, getAllUsersById } from 'src/services/roleService';
// import AddPermissionTab from './AddPermissionTab';
import AddUsersTab from './AddUsersTab';
import AppRightsTab from './AppRightsTab';

// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { getApprightrolelist, updateAppRight } from 'src/services/appRightsService';
import MUICheckbox from '../MUICheckbox/MUICheckbox';




interface NewRoleProps {
    closeModal: () => void;
    refreshPage: () => void;
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

interface ApiResponse {
    status: number;
    data: {
        result: number;
        data: any;
        messages: any;
    };
}

interface IMenuData {
    menuId: number;
    roleId: number;
    sortOrder: number;
    isDisplay: boolean;
    menuName: string;
    menuFeaturePermissions: MenuFeaturePermission[];
}

interface MenuFeaturePermission {
    menuFeatureId: number;
    menuFeature: string;
    hasPermission: boolean;
}

interface IUsersData {
    id?: any | null;
    firstName: string;
    lastName?: string | null | undefined;
    email: string;
    password: string;
    clientId: number;
    passwordResetKey?: any | null;
    resetKeySentOn?: any | null;
    isDeleted: boolean;
    isActive: boolean;
    timeZone?: any | null;
    phone?: any | null;
    roleId?: any | null;
    createdBy: string;
    createdOn: string;
    createdSource: string;
    modifiedBy?: any | null;
    modifiedOn?: any | null;
    modifiedSource?: any | null;
    //For user role
    hasRole: boolean;
    name: string;
    userID: any;
    hasWebAccess: boolean;
    hasAPIAccess: boolean;
    roleName: string | null;
}

interface IAppRights {
    appRightId: number;
    rightName: string;
    rightCode: string;
    isMenu: boolean;
    isSubMenu: boolean;
    hasSubMenu: boolean;
    menuOrder: number;
    roleId: number;
    roleName: string;
    hasRight: boolean;
    parentId: number; // Added missing property
    children?: IAppRights[]; // Optional children property
}

// interface SelectedUserId {
//     id: number;
//   }

function CustomTabPanel(props: TabPanelProps): JSX.Element {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 0 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number): any {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function AddNewRole({ closeModal, refreshPage }: NewRoleProps): JSX.Element {
    const [value, setValue] = useState<number>(0);
    const [isSaveLoading, setIsSaveLoading] = useState<boolean>(false)
    const [menuData, setMenuData] = useState<IMenuData[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [menuSearchData, setMenuSearchData] = useState<IMenuData[]>([])
    const [selectedMenuFeatureIds, setSelectedMenuFeatureIds] = useState<number[]>([]);
    const [isError, setIsError] = useState<boolean>(false)
    const [roleName, setRoleName] = useState<string>('');
    const [description, setDescription] = useState<string>('');
    const [userSearchData, setUserSearchData] = useState<IUsersData[]>([])
    const [roleUserData, setRoleData] = useState<IUsersData[]>([]);
    const [selectedUserIds, setSelectedUserIds] = useState<number[]>([]);
    const [appRightsData, setAppRightsData] = useState<IAppRights[]>([]);
    const [searchAppRightsData, setSearchAppRightsData] = useState<IAppRights[]>([]);
    const [selectedAppRightIds, setSelectedAppRightIds] = useState<number[]>([]);
    const [appRightData, setAppRightData] = useState<IAppRights[]>([]);
    const [isClientRole, setIsClientRole] = useState(false);
    console.log(menuSearchData);
    console.log(menuData)


    useEffect(() => {
        setLoading(true);
        getAllUsersById(0)
            .then((res: any) => {
                if (res.status === 200 && res.data.result === 1) {
                    const userDataWithAdditionalInfo = res.data.data.map((user: any) => ({
                        ...user,
                        fullname: `${user.name}`, // Combine first and last name
                        userID: user.userID, // User ID
                        hasRole: user.hasRole
                    }));
                    setRoleData(userDataWithAdditionalInfo);
                    setUserSearchData(userDataWithAdditionalInfo)
                    setLoading(false);
                }
            })
            .catch(
                error => console.log("error", error)
            )

        // getAllMenuPermissionsById(0)
        //     .then((res: ApiResponse) => {
        //         if (res.status === 200 && res.data.result === 1) {
        //             const roleDataWithPermission: any = res.data.data.map((permission: any) => ({
        //                 ...permission,
        //                 roleid: permission.roleId, // Role ID
        //                 rolename: 'Role Name',
        //             }));
        //             setMenuData(roleDataWithPermission);
        //             setMenuSearchData(roleDataWithPermission)
        //             setLoading(false);
        //         }
        //     })
        //     .catch(
        //         error => console.log("error", error)
        //     )
    }, [])

    useEffect(() => {
        getApprightrolelist(0)
            .then((res: ApiResponse) => {
                if (res.status === 200 && res.data.result === 1) {
                    const allAppRights = res.data.data as IAppRights[];
                    setAppRightsData(allAppRights); // ✅ include both menus and submenus
                    setSearchAppRightsData(allAppRights);
                }
            })
            .catch((err: unknown) => console.error('Error fetching app rights:', err));
    }, []);
    

    const handleChange = (event: React.SyntheticEvent, newValue: number): void => {
        setValue(newValue);
    };

    const handleSaveRole = (): void => {
        console.log(appRightData)
        if (roleName === "") {
            setIsError(true);
            return;
        }



        // @ts-ignore
        const userData = JSON.parse(localStorage.getItem("user"))

        const uniqueMenuFeatureIds = Array.from(new Set(selectedMenuFeatureIds)); // Remove duplicates
        const uniqueUserIds = Array.from(new Set(selectedUserIds)); // Remove duplicates

        // if (uniqueMenuFeatureIds.length === 0) {
        //     NotificationManager.error("Please select menu permissions", '', 5000);
        // } 
        if (uniqueUserIds.length === 0) {
            NotificationManager.error("Please select users", '', 5000);
        } else {

            let updatedAppRightData: IAppRights[] = [...appRightData];
            const hasAnyRights = updatedAppRightData.length > 0;

            if (!hasAnyRights) {
                const dashboardRight = appRightsData.find((right: IAppRights) => right.rightCode === 'DASHBOARD');
                if (dashboardRight) {
                    updatedAppRightData = [{
                        ...dashboardRight,
                        hasRight: true // ✅ explicitly setting hasRight to true
                    }];
                }
            }
            const formData: any = {
                roleName: roleName ? roleName.trim() : roleName,
                description: description ? description.trim() : description,
                isDeleted: false,
                IsActive: true,
                IsClientRole: isClientRole,
                // @ts-ignore
                createdBy: userData.id,
                appRightRoles: updatedAppRightData,
                // @ts-ignore
                userId: uniqueUserIds.map(id => ({ id })),
                clientId: userData.clientId
            };
            
            setIsSaveLoading(true)

            addRole(formData)
                .then(
                    (res: ApiResponse) => {
                        if (res.status === 200) {
                            if (res.data.result === 1) {
                                setSelectedUserIds([]);
                                setSelectedMenuFeatureIds([]);
                                // props.closeModal("refresh")
                                NotificationManager.success(NEW_ROLE_SUCCESS_MESSAGE, '', 5000);
                                refreshPage()
                            } else {
                                if (res.data.messages.length === 1) {
                                    NotificationManager.error(res.data.messages[0].message, '', 5000);
                                } else {
                                    NotificationManager.error(UNKNOWN_ERR, '', 5000);
                                }
                            }
                        }
                    }
                )
                .catch(
                    error => console.log("Error", error)
                )
                .finally(() => setIsSaveLoading(false))
        }
    }

    const handleCloseModal = (): void => {
        closeModal()
    }

    const handleRoleNameChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (e.target.value === "") {
            setIsError(true)
        } else {
            setIsError(false)
        }
        setRoleName(e.target.value);
    };

    const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        setDescription(e.target.value);
    };

    const handleMenuFeatureSelect = (menuFeatureId: any, checked: boolean): void => {
        let selectedIds;
        if (checked) {
            selectedIds = [...selectedMenuFeatureIds, ...menuFeatureId]
        } else {
            const set1: any = new Set(selectedMenuFeatureIds);
            const set2: any = new Set(menuFeatureId);

            const difference = [...set1].filter(
                (element) => !set2.has(element));

            selectedIds = difference
        }
        // const selectedIds = checked ? [...selectedMenuFeatureIds, menuFeatureId] : selectedMenuFeatureIds.filter(id => id !== menuFeatureId)
        setSelectedMenuFeatureIds(selectedIds);
    };

    const handleUserSelect = (userId: number, checked: boolean): void => {
        setSelectedUserIds(prevState =>
            checked
                ? [...prevState, userId] // Add userId if it doesn't exist in the array
                : prevState.filter(id => id !== userId) // Remove userId if it exists in the array
        );
    };

    const handleMenuSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const { value } = e.target;
        let menuDataArr = [...menuData]
        if (value !== "") {
            menuDataArr = menuDataArr.filter((menu: IMenuData) => {
                return menu.menuFeaturePermissions.some((menuFeature) => {
                    return menuFeature.menuFeature.toLowerCase().includes(value.toLowerCase());
                });
            });
        }
        setMenuSearchData(menuDataArr)
    }

    const handleUserSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const { value } = e.target;
        let userDataArr = [...roleUserData]
        if (value !== "") {
            userDataArr = userDataArr.filter((user: IUsersData) => {
                return user.name.toLowerCase().includes(value.toLowerCase())
            })
        }
        setUserSearchData(userDataArr)
    }

    const handleAppRightsSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const { value } = e.target;
        const searchTerm = value.toLowerCase();
        
        if (!searchTerm) {
            setSearchAppRightsData([...appRightsData]);
            return;
        }
        
        // Map all rights by their ID for quick lookup
        const rightsMap = new Map<number, IAppRights>();
        appRightsData.forEach((right) => {
            rightsMap.set(right.appRightId, { ...right, children: [] });
        });
        
        // Build the tree
        const menuTree: IAppRights[] = [];
        rightsMap.forEach((item) => {
            if (item.parentId === 0) {
            menuTree.push(item);
            } else {
            const parent = rightsMap.get(item.parentId);
            if (parent) {
                parent.children?.push(item);
            }
            }
        });
        
        // Recursive search through tree
        const searchTree = (nodes: IAppRights[]): IAppRights[] => {
            const results: IAppRights[] = [];
        
            for (const node of nodes) {
            const matchedChildren = node.children ? searchTree(node.children) : [];
        
            const isMatch = node.rightName.toLowerCase().includes(searchTerm);
            if (isMatch || matchedChildren.length > 0) {
                results.push({
                ...node,
                children: isMatch ? node.children : matchedChildren, // keep all children if main menu matched, else only matched ones
                });
            }
            }
        
            return results;
        };
        
        const filtered = searchTree(menuTree);
        setSearchAppRightsData(flattenTree(filtered));
    };
        
    const flattenTree = (items: IAppRights[]): IAppRights[] => {
    const result: IAppRights[] = [];
    
    const recurse = (nodes: IAppRights[]):void => {
        for (const node of nodes) {
            const { children, ...rest } = node;
            result.push(rest);
            if (children && children.length > 0) {
                recurse(children);
            }
        }
    };
    
    recurse(items);
    return result;
    };

    const handleAppRightSelect = (appRightIdOrIds: number | number[], checked: boolean): void => {
        let updatedIds = [...selectedAppRightIds];
        const ids = Array.isArray(appRightIdOrIds) ? appRightIdOrIds : [appRightIdOrIds];
    
        if (checked) {
            ids.forEach(id => {
                if (!updatedIds.includes(id)) updatedIds.push(id);
            });
        } else {
            updatedIds = updatedIds.filter(id => !ids.includes(id));
        }
    
        setSelectedAppRightIds(updatedIds);
    };

    return (
        <>
            <div className="px-[16px] pt-[10px]">
                <div className="grid">
                    <div className="mb-[5px] w-full relative" style={{ marginBottom: '30px' }}>
                        <TextField
                            id="outlined-basic"
                            className='disabled-input'
                            label={ENTER_NEW_ROLE}
                            variant="outlined"
                            fullWidth
                            name='RoleName'
                            value={roleName}
                            onChange={handleRoleNameChange}
                            autoComplete='off'
                            InputProps={{
                                inputProps: {
                                    style: { textAlign: "center", color: '#343434', fontSize: '18px', fontWeight: '700', WebkitTextFillColor: '#343434', padding: '9px 14px' },
                                    placeholder: `${ENTER_NEW_ROLE}`
                                }
                            }}
                            sx={{
                                "& label": {
                                    textAlign: "center"
                                },
                                backgroundColor: "#F5F5F5"
                            }}
                            error={isError}
                        />
                        {
                            isError && <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal"><img src="/assets/images/attention.svg" alt="email" width={12} height={12} className="mr-1" /> Please enter role name</div>
                        }
                    </div>
                </div>
                <div className="mb-[5px] w-full relative" style={{ marginBottom: '20px' }}>
                    <div style={{ marginBottom: '20px' }}>
                        <TextField
                            id="outlined-basic"
                            className='disabled-input'
                            label={ENTER_NEW_DESCRIPTION}
                            variant="outlined"
                            fullWidth
                            name='Description'
                            value={description}
                            onChange={handleDescriptionChange}
                            autoComplete='off'
                            InputProps={{
                                inputProps: {
                                    style: { textAlign: "center", color: '#343434', fontSize: '18px', fontWeight: '700', WebkitTextFillColor: '#343434', padding: '9px 14px' },
                                    placeholder: `${ENTER_NEW_DESCRIPTION}`
                                }
                            }}
                            sx={{
                                "& label": {
                                    textAlign: "center"
                                },
                                backgroundColor: "#F5F5F5"
                            }}
                        />
                    </div>
                </div>
                <div className="mb-[5px] w-full relative" style={{ marginBottom: '20px' }}>
                    <FormControlLabel sx={{ marginLeft: '-9px' }} 
                        control={
                            <MUICheckbox checked={isClientRole} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setIsClientRole(e.target.checked)} 
                            sx={{color: '#343434','&.Mui-checked': {color: '#343434',},}}/>
                        }
                        label="Client Role"
                    />
                </div>
            </div>

            <div className="mt-1">
                <Box sx={{ width: '100%', padding: 0 }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example"
                            TabIndicatorProps={{
                                style: {
                                    backgroundColor: "#D6242C"
                                }
                            }}>
                            {/* <Tab label={LABEL_UPDATE_PERMISSION} {...a11yProps(0)} /> */}
                            <Tab label="App Rights" {...a11yProps(0)} />
                            <Tab label={LABEL_UPDATE_USERS} {...a11yProps(1)} />
                        </Tabs>
                    </Box>
                    {/* <CustomTabPanel value={value} index={0}>
                        <div className='tab-content'>
                            <div className="form-control mt-2 border-t-[1px] border-b-[1px] border-[#D9D9D9] pb-2" style={{ borderTop: 'none' }}>
                                <input type="text" placeholder="Search permissions" onChange={handleMenuSearch} style={{ border: '0', background: 'transparent url(/assets/images/icons/SearchIcon.svg) no-repeat 22px', paddingLeft: '50px', fontSize: '14px', fontWeight: '400', color: '#3a3a3a' }} />
                            </div>
                        </div>
                        {
                            loading ? <div className='flex justify-center items-center relative top-[50%]'><span className="loading loading-spinner text-primary"></span></div> :
                                <AddPermissionTab
                                    page={"Permission"}
                                    menuData={menuSearchData}
                                    closeModal={closeModal}
                                    selectedMenuFeatureIds={selectedMenuFeatureIds}
                                    setSelectedMenuFeatureIds={setSelectedMenuFeatureIds}
                                    onMenuFeatureSelect={(menuFeatureId, checked) => handleMenuFeatureSelect(menuFeatureId, checked)}
                                />
                        }

                    </CustomTabPanel> */}
                    <CustomTabPanel value={value} index={1} >
                        <div className='tab-content'>
                            <div className="form-control mt-2 border-b-[1px] border-[#D9D9D9] pb-2" style={{ borderTop: 'none' }}>
                                <input type="text" placeholder="Search users" onChange={handleUserSearch} style={{ border: '0', background: 'transparent url(/assets/images/icons/SearchIcon.svg) no-repeat 22px', paddingLeft: '50px', fontSize: '14px', fontWeight: '400', color: '#3a3a3a' }} />
                            </div>
                        </div>
                        {
                            loading ? <div className='flex justify-center items-center relative top-[50%]'><span className="loading loading-spinner text-primary"></span></div> :
                                <AddUsersTab
                                    page={"Users"}
                                    roleData={userSearchData}
                                    closeModal={closeModal}
                                    selectedUserIds={selectedUserIds}
                                    setSelectedUserIds={setSelectedUserIds}
                                    onUserSelect={(userId, checked) => handleUserSelect(userId, checked)}
                                />
                        }
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={0}>
                        <div className='tab-content'>
                            <div className="form-control mt-2 border-t-[1px] border-b-[1px] border-[#D9D9D9] pb-2" style={{ borderTop: 'none' }}>
                                <input type="text" placeholder="Search app rights" onChange={handleAppRightsSearch} style={{ border: '0', background: 'transparent url(/assets/images/icons/SearchIcon.svg) no-repeat 22px', paddingLeft: '50px', fontSize: '14px', fontWeight: '400', color: '#3a3a3a' }} />
                            </div>
                        </div>
                        {
                            loading ? <div className='flex justify-center items-center relative top-[50%]'><span className="loading loading-spinner text-primary"></span></div> :
                            <AppRightsTab
                                page="AppRights"
                                menuData={searchAppRightsData}
                                closeModal={closeModal}
                                setAppRightData={setAppRightData}
                                // setSelectedMenuFeatureIds={setSelectedAppRightIds}
                                onMenuFeatureSelect={handleAppRightSelect}
                                persistedAppRightData={appRightData}
                            />
                        }
                    </CustomTabPanel>
                </Box>
            </div>

            <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
                <div className="w-full relative col-span-3">
                    <button type='button' className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted" disabled={isSaveLoading} onClick={handleCloseModal}>{LABEL_BTN_CANCEL}</button>
                </div>
                <div className="w-full relative col-span-3">
                    <button className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]" onClick={() => handleSaveRole()} disabled={isSaveLoading}>{!isSaveLoading ? `${LABEL_BTN_SAVE}` : <span className="loading loading-spinner loading-xs text-white"></span>}</button>
                </div>
            </div>
        </>
    )
}

export default AddNewRole